<template>
  <div class="country-scorecard">
    <h4 class="f-title-6">{{ family }}</h4>
    <div
      class="country-scorecard__policy-type"
      v-for="policyGroup in policiesByPolicyType"
      :key="policyGroup.policyType"
    >
      <div class="country-scorecard__header">
        <p class="f-ui-1-bold">{{ policyGroup.policyType }}</p>
        <p class="f-ui-3">
          {{ getDescription(policyGroup.policyType) }}
        </p>
      </div>
      <PolicyListing
        :policies="policyGroup.policies"
        :categories="policyGroup.categories"
        :test="test"
      />
    </div>
    <div v-if="policiesByPolicyType.length === 0">
      <p class="f-ui-3">No policies in this area.</p>
    </div>
  </div>
</template>

<script>
import PolicyListing from "./PolicyListing.vue";
import tags from "../assets/tags.json";
export default {
  props: {
    country: {
      type: String,
      required: true,
    },
    topic: {
      type: String,
      required: true,
    },
    family: {
      type: String,
      required: true,
    },
    policies: {
      type: Array,
      required: true,
    },
    test: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PolicyListing,
  },
  computed: {
    relevantPolicyTypes() {
      const { topic, family } = this;
      return tags.reduce(
        (policyTypes, tag) =>
          tag.topic === topic &&
          (family === "All" || tag.family === family) &&
          !policyTypes.includes(tag.policyType)
            ? [...policyTypes, tag.policyType]
            : policyTypes,
        []
      );
    },
    policiesByPolicyType() {
      const { policies, topic } = this;
      return this.relevantPolicyTypes
        .map((policyType) => {
          const categories = this.getRelevantCategories(policyType);
          const relevantPolicies = policies.filter(
            (policy) =>
              policy.topic.includes(topic) &&
              policy.type.includes(policyType) &&
              (!categories[0] ||
                (policy.category &&
                  policy.category.some((cat) => categories.includes(cat))))
          );
          return {
            policyType,
            policies: relevantPolicies,
            categories,
          };
        })
        .filter((pt) => pt.policies.length > 0);
    },
  },
  methods: {
    getRelevantCategories(policyType) {
      const { topic } = this;
      return tags.reduce(
        (categories, tag) =>
          tag.policyType === policyType &&
          tag.topic === topic &&
          !categories.includes(tag.category)
            ? [...categories, tag.category]
            : categories,
        []
      );
    },
    getDescription(policyType) {
      const { topic } = this;
      const tag = tags.find(
        (tag) => tag.topic === topic && tag.policyType === policyType
      );
      return tag ? tag.description || "" : "";
    },
  },
};
</script>

<style scoped>
.country-scorecard {
  border: 1px solid #f2f2f2;
  border-radius: 16px;
  padding: 20px;
  margin: 24px 0px;
}
.country-scorecard__policy-type:not(:last-child) {
  margin-bottom: 60px;
}
.country-scorecard__header {
  border-bottom: 1px solid #000;
}
.country-scorecard__header p {
  max-width: 644px;
  margin-bottom: 12px;
}
.country-scorecard .score-legend {
  margin-left: 14px;
}
</style>